export default __webpack_public_path__ + "static/pic2-57be24152b57132d34803ba5b0d4835f.png";